module.exports = __webpack_public_path__ + "img/Net5.139ab6bb.svg";